import { useMemo } from "react"

import { API_MODULE_HORIZONTAL_SIGNING, useHorizontalSigningCampaignElements } from "@l2r-front/l2r-app-city"
import { useNetworksStateContext, useRoleIsReadOnly, useSubNetworksWithWriteAccess } from "@l2r-front/l2r-networks"
import { Campaign } from "@l2r-front/l2r-proptypes"

export function useIsCampaignWriter(campaign: Campaign | undefined | null): boolean {

    const { selectedNetwork, selectedSubNetworkSlugs } = useNetworksStateContext()

    const { data, isLoading } = useHorizontalSigningCampaignElements(campaign?.uuid, {
        enabled: !!campaign?.uuid && campaign?.campaign_type === API_MODULE_HORIZONTAL_SIGNING,
    })

    const campaignSubNetworkSlugs = useMemo(() => {
        const subNetworkSlugs = new Set<string>()
        data?.forEach(element => {
            element.sub_networks.forEach(slug => subNetworkSlugs.add(slug))
        })
        return Array.from(subNetworkSlugs)
    }, [data])

    const readOnly = useRoleIsReadOnly(campaignSubNetworkSlugs, campaign?.campaign_type)
    const subnetworksWithWriteAccess = useSubNetworksWithWriteAccess(campaignSubNetworkSlugs, campaign?.campaign_type)
    const isWriter = useMemo(() => {
        if (selectedNetwork?.children?.length && campaignSubNetworkSlugs.length > 0) {
            return subnetworksWithWriteAccess.length === campaignSubNetworkSlugs.length
                && campaignSubNetworkSlugs.every(slug => selectedSubNetworkSlugs.includes(slug))
        }
        return !readOnly
    }, [campaignSubNetworkSlugs, selectedNetwork, readOnly, selectedSubNetworkSlugs, subnetworksWithWriteAccess])

    if (!campaign || isLoading) {
        return false
    }

    return isWriter
}
